// import React, { useEffect, useState } from "react";
// import WeeklyRevenueChart from "./weeklyRevenueChart";
// // import NewBarChart from "./newBarChart";
// import performRequest from "../../../api/request";
// import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
// import LoadingPage from "../../../Components/layouts/loading";
// import { Toast } from "../../../CustomComponent/toast";

// const Barchart = () => {
//   const [weeklyRevenue, setWeeklyRevenue] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     setLoading(true);
//     performRequest(
//       "GET",
//       "/incentive/getTotalWeekRevenueGenratedWeekly"
//     )
//       .then((res) => {
//         if (res.status === 200) {
//           setWeeklyRevenue(res?.data?.weeklyRevenue);
//         } else {
//           Toast("error", "Error while getting data!");
//         }
//       })
//       .catch((err) => {
//         CustomErrorResponse(err);
//       })
//       .finally(() => setLoading(false));
//   }, []);

//   if (loading) {
//     return <LoadingPage />;
//   }

//   return (
//     <div className="container py-4 ">
//       <WeeklyRevenueChart weeklyRevenueData={weeklyRevenue} />
//     </div>
//   );
// };

// export default Barchart;

import React, { useEffect, useState } from "react";
// import WeeklyStepGraph from "./weeklyStepGraph";
import NewWeeklyRevenueChart from "./newBarChart";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";

const Barchart = () => {
  const [weeklyRevenue, setWeeklyRevenue] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // For handling month and year selection
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // Default to current month
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Default to current year

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch data when month or year changes
  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      `/incentive/getNewSelectLastThreeMonthsWeeklyRevenue?month=${selectedMonth}&year=${selectedYear}`
    )
      .then((res) => {
        if (res.status === 200) {
          setWeeklyRevenue(res?.data?.monthlyRevenue);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [selectedMonth, selectedYear]);

  if (loading) {
    return <LoadingPage />;
  }

  const getMonthName = (monthIndex) => {
    return new Date(0, monthIndex).toLocaleString("default", { month: "long" });
  };

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  return (
    <div className="container py-4">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4">
        <h3 className="card-title text-xl font-semibold">
          Monthly Revenue Overview
        </h3>
        <div className="flex gap-2 mt-2 md:mt-0 p-2">
          {/* Year Selector */}
          <select
            className="border p-2 rounded p-2"
            value={selectedYear}
            onChange={handleYearChange}
          >
            {/* Assuming 2022 to current year as the available options */}
            {Array.from({ length: 5 }, (_, index) => 2022 + index).map(
              (year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              )
            )}
          </select>

          {/* Month Selector */}
          <select
            className="border p-2 rounded"
            value={selectedMonth}
            onChange={handleMonthChange}
          >
            {Array.from({ length: 12 }, (_, index) => (
              <option key={index} value={index + 1}>
                {getMonthName(index)} {/* Convert 0-indexed to 1-indexed */}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* WeeklyStepGraph now accepts the selected month's data */}
      <NewWeeklyRevenueChart weeklyRevenueData={weeklyRevenue} />
    </div>
  );
};

export default Barchart;
